import { getColorFromAppState } from '../../../utils/Helper'
import { styled } from 'twin.macro'
import SimpleFileFailedOriginalIcon from '../../../assets/img/simple-file-failed-icon.svg'

const SimpleFileFailedIcon = styled(SimpleFileFailedOriginalIcon).withConfig({
    shouldForwardProp: (prop) => {
        return !(['color', 'circleColor', 'xColor'].includes(prop as string))
    }
})<{
    color?: AppColor
    circleColor?: AppColor
    xColor?: AppColor
}>`
  path {
    stroke: ${({ color = { value: 'primary', level: '300' }, ...props }) => {
        return getColorFromAppState({ ...props, $color: color })
    }};
  }

  circle.circle {
    fill: ${({ circleColor = { value: 'error', level: '400' }, ...props }) => {
        return getColorFromAppState({ ...props, $color: circleColor })
    }};
  }

  rect.x {
    fill: ${({ xColor = 'white', ...props }) => {
        return getColorFromAppState({ ...props, $color: xColor })
    }};
  }
`

export default SimpleFileFailedIcon

